// extracted by mini-css-extract-plugin
export default {"componentWrapper":"OffersDedicated_componentWrapper__XCJkj","header":"OffersDedicated_header__yIyfo","searchFormWrapper":"OffersDedicated_searchFormWrapper__gTFcI"};